import React, { Component } from 'react';
/* CSS */
import '../../../../Assets/EnsembleStyles/EnsHome.css';

/* Components */
import NavigationBar from '../../../EnsembleComponents/Common/Layouts/NavigationBar/Navigationbar';                                    /* Navigation Bar */
import TitleBar from '../../../EnsembleComponents/Common/Layouts/TitleBar/TitleBar';                                              /* Titile  Bar */

import InvoicesSubRouting from '../../../EnsembleComponents/Common/Layouts/SubRouting/InvoiceSubRouting';



/* Side Bar */


/* Footer */
import Footer from '../../../EnsembleComponents/Common/Layouts/Footer/EnsembleFooter';
import { connect } from 'react-redux';


class NewRequest extends Component {
    showSettings(event) {
        event.preventDefault();
    }
    componentDidMount(){
        let StateVal = (this.props.OnPremises !== undefined && this.props.OnPremises !== null) ? this.props.OnPremises : false;
        this.setState({OnPremisesState:StateVal});
        }
    componentWillReceiveProps(nextProps){
        if (this.props !== nextProps) {
            console.log('calllingg',nextProps.OnPremises);
            let StateVal = (nextProps.OnPremises !== undefined && nextProps.OnPremises !== null) ? nextProps.OnPremises : false;
            this.setState({OnPremisesState:StateVal});
        }
    }
    constructor(props) {
        super(props);
        this.state = {
            sideSize: 300,
            drag: 300,
            OnPremisesState : false
        }
        this.toggleSide = this.toggleSide.bind(this);
        this.handleDrag = this.handleDrag.bind(this);
    }

    toggleSide(action) {
        switch (action) {
            case "open": this.setState({ sideSize: 200, drag: 200 });
                break;
            case "close": this.setState({ sideSize: 1, drag: 1 });
                break;
            default : break;
        }

    }

    handleDrag(width) {
        this.setState({ drag: width + 10 });
    }


    render(OnPremises) {
        
        return (
            <div className="Ensemble">
                {/* Navigation Bar && Title bar displays the title of the page */}
                {
                    !this.state.OnPremisesState ? <div><NavigationBar />
                        <TitleBar parentToChildData={"Invoices"} istabView={false}/>
                        <div className="Ensemble_Content margin_top">
                            <InvoicesSubRouting match={this.props.match} />
                        </div>
                        <Footer />
                    </div> : <div className="Ensemble_Content_FullPage">
                            <InvoicesSubRouting match={this.props.match} />
                        </div>
                }
            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        OnPremises: state.authService.IsOnPremise
    };
};

export default connect(mapStateToProps, null)(NewRequest);
